<div class="menu-items-content-container">
  <div class="lists-container">
    <mat-card>
      <div *ngIf="menuItemType === 'checklist'" class="lists">
        <div
          *ngFor="let item of listItems"
          class="list-item"
          [ngClass]="selectedListItem.id === item.id ? 'active' : 'inactive'"
          (click)="onListItemChange(item)"
          [attr.data-test-id]="item.id"
        >
          <div class="name" data-test-id="list-name">
            {{ item.name.en }}
          </div>
          <div class="icon">
            <svg
              *ngIf="item.status === 'inProgress'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
              <path
                d="M21 12C21 13.78 20.4722 15.5201 19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271C8.49836 20.4798 6.89471 19.6226 5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17293 13.7558C2.82567 12.01 3.0039 10.2004 3.68508 8.55585C4.36627 6.91131 5.51983 5.50571 6.99987 4.51677C8.47991 3.52784 10.22 3 12 3V12H21Z"
                fill="#9E7BFF"
              />
            </svg>
            <svg
              *ngIf="item.status === 'open'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
            </svg>
            <svg
              *ngIf="item.status === 'done'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
              <circle cx="12" cy="12" r="9" fill="#9E7BFF" />
              <path
                d="M11.536 16.071L8 12.535L9.414 11.121L11.536 13.243L15.778 9L17.192 10.414L11.536 16.071Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
      <div *ngIf="menuItemType === 'metriclist'" class="lists">
        <div class="add-metric">
          <div class="add-metric-button">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 6V0H8V6H14V8H8V14H6V8H0V6H6Z" fill="#9E7BFF" />
            </svg>
            <span class="add-metric-text">Add Metric</span>
          </div>
        </div>
        <div
          *ngFor="let item of listItems"
          class="list-item"
          [ngClass]="selectedListItem.id === item.id ? 'active' : 'inactive'"
          (click)="onListItemChange(item)"
          [attr.data-test-id]="item.id"
        >
          <div class="name metric-name" data-test-id="list-name">
            <span>{{ item.name.en }}</span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7496 5.71193L14.2851 9.24743L6.03553 17.497H2.5V13.9615L10.7496 5.71193ZM11.9281 4.53342L13.6958 2.76565C14.0213 2.44022 14.5489 2.44022 14.8743 2.76565L17.2314 5.12268C17.5568 5.44811 17.5568 5.97575 17.2314 6.30118L15.4636 8.06895L11.9281 4.53342Z"
                fill="#9E7BFF"
              />
            </svg>
          </div>
          <div class="icon">
            <svg
              *ngIf="item.status === 'inProgress'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
              <path
                d="M21 12C21 13.78 20.4722 15.5201 19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271C8.49836 20.4798 6.89471 19.6226 5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17293 13.7558C2.82567 12.01 3.0039 10.2004 3.68508 8.55585C4.36627 6.91131 5.51983 5.50571 6.99987 4.51677C8.47991 3.52784 10.22 3 12 3V12H21Z"
                fill="#9E7BFF"
              />
            </svg>
            <svg
              *ngIf="item.status === 'open'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
            </svg>
            <svg
              *ngIf="item.status === 'done'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
              <circle cx="12" cy="12" r="9" fill="#9E7BFF" />
              <path
                d="M11.536 16.071L8 12.535L9.414 11.121L11.536 13.243L15.778 9L17.192 10.414L11.536 16.071Z"
                fill="white"
              />
            </svg>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0006 8.82208L14.1253 4.69727L15.3038 5.87577L11.1791 10.0006L15.3038 14.1253L14.1253 15.3038L10.0006 11.1791L5.87577 15.3038L4.69727 14.1253L8.82208 10.0006L4.69727 5.87577L5.87577 4.69727L10.0006 8.82208Z"
                fill="#9BA6B0"
              />
            </svg>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="form-container" data-test-id="form-container">
    <mat-card>
      <div class="wrapper" data-test-id="wrapper">
        <div
          class="form-head"
          data-test-id="form-head"
          [ngStyle]="{
            'border-bottom': menuItemType === 'metricslist' && 'none'
          }"
        >
          <div class="form-head-left" data-test-id="form-head-left">
            <p *ngIf="selectedListItem" data-test-id="list-name">
              {{ selectedListItem.name.en }}
            </p>
          </div>
          <div class="form-head-right">
            <div class="button btn-secondary" data-test-id="save-button">
              <span>Save</span>
            </div>
            <div class="button btn-primary" data-test-id="submit-button">
              <span>Submit</span>
            </div>
          </div>
        </div>
        <div class="form-body" data-test-id="form-body">
          <app-surveyjs-form
            *ngIf="questionnaire"
            [survey]="questionnaire.survey"
          ></app-surveyjs-form>
          <app-spreadsheet
            *ngIf="metricData"
            [metricData]="metricData"
          ></app-spreadsheet>
        </div>
      </div>
    </mat-card>
  </div>
</div>
